import { render, staticRenderFns } from "./StageActivityActions.vue?vue&type=template&id=1023ac6c&"
import script from "./StageActivityActions.vue?vue&type=script&lang=ts&"
export * from "./StageActivityActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports